import React from "react";

const License = () => {
  return (
    <>
      <h2>License</h2>
      <hr />
      <p>
        <a
          href="https://choosealicense.com/licenses/mit/"
          target="_blank"
          rel="noopener noreferrer"
        >
          MIT License
        </a>
      </p>

      <p>Copyright (c) 2023 Moshe Atia Poston.</p>

      <p>
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of this software and associated documentation files (the
        "Software"), to deal in the Software without restriction, including
        without limitation the rights to use, copy, modify, merge, publish,
        distribute, sublicense, and/or sell copies of the Software, and to
        permit persons to whom the Software is furnished to do so, subject to
        the following conditions:
      </p>

      <p>
        The above copyright notice and this permission notice shall be included
        in all copies or substantial portions of the Software.
      </p>

      <p>
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </p>
      <br />
      <h2>Contact</h2>
      <hr />
      <p>
        If you detect any bug in the program, please reach out to me at:{" "}
        <a href="mailto:mailto:moshikoatia@gmail.com">moshikoatia@gmail.com</a>.
      </p>
    </>
  );
};

export default License;
